export const CENTRA_PRICELIST_ID = {
    aud: 23,
    cad: 27,
    chf: 33,
    czk: 32,
    dkk: 25,
    eur: 31,
    gbp: 24,
    jpy: 30,
    nok: 29,
    nzd: 26,
    pln: 28,
    sek: 19,
    usd: 20
} as const

export type CentraPricelistId =
    (typeof CENTRA_PRICELIST_ID)[keyof typeof CENTRA_PRICELIST_ID]
